import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertQuimica'
})
export class ConvertQuimicaPipe implements PipeTransform {

  transform(value: any, args ?: any): any {
    switch (value) {
      case 1:
        return 'Luzes';
      case 2:
        return 'Relaxamento';
      case 3:
        return 'Alisamento';
      case 4:
        return 'Tintura';
    }
  }

}
